(function () {
    'use strict';

    angular.module('app')
        .factory('Asociarse', Service);

    /* @ngInject */
    function Service($resource) {
        var entidad = "asociarse";
        return $resource('api/' + entidad);
    }

})();
